<template>
  <h-frame type="left">
    <div class="leftCommunity">
      <div>
        <x-title>入住信息 </x-title>
        <div class="rightOneBox">
          <div class="warn">
            <div class="blueColor">
              {{ count == 0 ? 0 : ((houseNum / count) * 100).toFixed(2) }}%
            </div>
            <div class="warnText">入住率</div>
          </div>
          <div class="warnright">
            <!-- <div class="warnTitle">今日预警:70</div> -->
            <div class="warnItem">
              <div class="itemBg">
                <span class="itenSize">{{ count }} </span>
                <span>房屋总数</span>
              </div>
              <div class="itemBg">
                <span class="itenSize">{{ houseNum }}</span>
                <span>入住户数</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <x-title>住户统计</x-title>
        <div class="leftpeople">
          <div class="yellowColor">性别占比</div>
          <div class="peopleecharts">
            <div class="oneBox">
              <div class="oneItem">
                <span class="bluecolore">男:</span
                >{{ sex["男"] ? sex["男"] : 0 }}
              </div>
              <div class="oneItem">
                <span class="bluecolore">女:</span
                >{{ sex["女"] ? sex["女"] : 0 }}
              </div>
            </div>
            <div class="oneBluebg">
              <div
                class="bluecount"
                :style="{
                  width: (100 / (sex['男'] + sex['女'])) * sex['男'] + '%',
                }"
              >
                {{ sex["男"] }}
              </div>
              <div class="noBlue">{{ sex["女"] ? sex["女"] : 0 }}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="yellowColor">年龄分布</div>
        <leftAgeEcharts></leftAgeEcharts>
      </div>
      <div>
        <div class="yellowColor">租房占比</div>
        <leftHouseEcharts></leftHouseEcharts>
      </div>
      <!--  -->
    </div>
  </h-frame>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  inject,
  watchEffect,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import leftAgeEcharts from "./leftAgeEcharts.vue";
import leftHouseEcharts from "./leftHouseEcharts.vue";
import {
  houseCount,
  houseinHouseNum,
} from "@/api/dataAnalysis/housingAnalysis.js";

import { sex } from "@/api/dataAnalysis/populationAnalysis.js";

export default defineComponent({
  name: "",
  components: {
    leftAgeEcharts,
    leftHouseEcharts,
  },
  props: {},
  setup(props) {
    const data = reactive({
      count: 0,
      houseNum: 0,
      sex: {},
    });
    const refData = toRefs(data);
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          sexAxios();
          houseinHouseNumAxios();
          houseCountAxios();
        });
      }
    });
    // 房屋 总数
    const houseCountAxios = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const ress = await houseCount(param);
      data.count = ress.data && ress.data.value;
    };
    // 入住户数
    const houseinHouseNumAxios = async () => {
      data.houseNum = 0;
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const ress = await houseinHouseNum(param);
      data.houseNum = ress.data[0] && ress.data[0].value;
    };
    // 性别占比
    const sexAxios = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const ress = await sex(param);
      let sexObj = {};
      ress.data.map((item) => {
        sexObj[item.name] = item.value;
      });
      data.sex = sexObj;
    };
    sexAxios();
    houseinHouseNumAxios();
    houseCountAxios();
    return { ...refData, houseCountAxios };
  },
});
</script>
<style lang="scss" scoped>
.leftCommunity {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 15px;
  overflow: auto;
  color: white;
  display: grid;
  grid-template-rows: 25% 20% 25% 30%;
  .rightOneBox {
    width: 100%;
    display: flex;
    margin: 15px 0 7px 12px;
    .warn {
      width: 120px;
      height: 120px;
      background-image: url("~@/assets/images/home/yjbg.png");
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .warnText {
        font-size: 16px;
      }
    }
    .warnright {
      display: flex;
      flex-direction: column;
      flex: 1;
      // color: #a6bfda;
      .warnTitle {
        color: #73f1f3;
        text-align: center;
        // line-height: 24px;
        margin-bottom: 8px;
      }
      .warnItem {
        display: flex;
        justify-content: space-evenly;
        .itemBg {
          width: 78px;
          height: 62px;
          display: flex;
          flex-direction: column;
          background-image: url("~@/assets/images/home/yujing.png");
          background-size: 100% 100%;
          text-align: center;
          .itenSize {
            margin-top: 14px;
            margin-bottom: 30px;
          }
          span {
            font-size: 16px;
          }
        }
      }
    }
  }
  .leftpeople {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    .peopleecharts {
      display: flex;
      flex-direction: column;

      .oneBox {
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        .bluecolore {
          color: #91c8ff;
        }
      }
      .oneBluebg {
        width: 100%;
        height: 30px;
        background: rgba(0, 143, 187, 1);
        border-radius: 4px;
        position: relative;

        .bluecount {
          width: 200px;
          text-align: center;
          height: 100%;
          position: absolute;
          border-radius: 4px;
          box-shadow: 0 0 10px 3px #00c9fa inset;
          background: #00a8ec;
          z-index: 2;
          line-height: 30px;
        }
        .noBlue {
          position: absolute;
          right: 20px;
          line-height: 30px;
        }
      }
    }
  }
  .yellowColor {
    width: 100%;
    text-align: center;
    color: #f3ce61;
    line-height: 40px;
  }
}
</style>
